/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VoiceAgentFeaturesService {
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiAppVoiceAgentFeaturesGetGptLiveEnabled(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/voiceAgentFeatures/getGptLiveEnabled',
        });
    }
}
